"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgBtCollapse = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgBtCollapse = function SvgBtCollapse(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.6667 20L12.6667 16C12.6667 15.8232 12.5965 15.6536 12.4715 15.5286C12.3465 15.4036 12.1769 15.3333 12.0001 15.3333L8.00008 15.3333",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.00006 20L12.4734 15.5267",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M20 12.6667L16 12.6667C15.8232 12.6667 15.6536 12.5965 15.5286 12.4715C15.4036 12.3465 15.3333 12.1769 15.3333 12.0001L15.3333 8.00008",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.5267 12.4734L20 8.00006",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

exports.SvgBtCollapse = SvgBtCollapse;